import React, { useEffect } from "react";
import useUserActivity from "../hooks/useUserActivity";

const AdminPageWrapper = ({ children }) => {
  const { isUserActive, getLastActivity, isAdminPage } = useUserActivity();

  useEffect(() => {
    if (!isAdminPage) return;

    // Set up periodic session extension for active users
    // const sessionExtensionInterval = setInterval(
    //   async () => {
    //     if (isUserActive(4)) {
    //       // Check if active within last 4 minutes
    //       try {
    //         const userData = JSON.parse(
    //           localStorage.getItem("userData") || "{}",
    //         );
    //         const userDetails = JSON.parse(
    //           localStorage.getItem("userDetails") || "{}",
    //         );

    //         if (userData && userDetails.id) {
    //           const lastActivity = getLastActivity();

    //           // Call extend-session API
    //           const response = await fetch(
    //             `${process.env.REACT_APP_BACKEND_URL}/extend-session`,
    //             {
    //               method: "POST",
    //               headers: {
    //                 "Content-Type": "application/json",
    //               },
    //               body: JSON.stringify({
    //                 user_id: userDetails.id,
    //                 last_activity: lastActivity,
    //               }),
    //             },
    //           );

    //           if (response.ok) {
    //             const data = await response.json();

    //             // Update tokens in localStorage
    //             localStorage.setItem("userData", JSON.stringify(data.token));
    //             localStorage.setItem(
    //               "userRefreshToken",
    //               JSON.stringify(data.refresh_token),
    //             );

    //             console.log("Session extended successfully for active user");
    //           }
    //         }
    //       } catch (error) {
    //         console.error("Error extending session:", error);
    //       }
    //     }
    //   },
    //   3 * 60 * 1000,
    // ); // Check every 3 minutes

    // return () => {
    //   clearInterval(sessionExtensionInterval);
    // };
  }, [isAdminPage, isUserActive, getLastActivity]);

  return <>{children}</>;
};

export default AdminPageWrapper;
